
export default {
  title: 'Job List',
  talent: 'Talent',
  opportunity: 'Opportunity',
  viewJobs: 'View Jobs',
  notSpecified: 'Not Specified',
  multiLocations: 'Multi-locations',
  internalJob: 'Internal Only',
  tip: {
    noJobMatched: 'Oops! No jobs are matched.',
    tryOtherKeywords: 'Please try other keywords'
  },
  btn: {
    winRewards: 'WIN REWARDS'
  }
}
